import { LOCALES } from '@marketplace/i18n';

export const registrationCompletionI18n = {
  [LOCALES.ENG]: {
    registrationCompletion_message: "A confirmation e-mail message has been sent to the address you provided. Please verify your address via the link provided in that message.",
    registrationCompletion_title: "Registration Successful",
    registrationCompletion_redirect: "You will be redirected to the login  page in {seconds} seconds.",
  },
};
